import loggingService from '../services/util/loggingService'

var serviceName = 'roleService'
var path = '/Lookup/Role/'
var isDebug = false

const RoleEnum = {
    Administrator: 'Administrator',
    CountyAdministrator: 'County Administrator',
    CountyCoroner: 'County Coroner',
    CountyCoronerStaff: 'County Coroner Staff',
    LawEnforcement: 'Law Enforcement',
    Public: 'Public',
    Family: 'Family'
}

function list (http) {
    loggingService.log(isDebug, serviceName, 'list')

    return http.get(path + 'List')
}

export default {
    RoleEnum: RoleEnum,
    list: list
}
